export default __webpack_public_path__ + "static/Creative_Comm_benefit_2-5b40773c7f0c63c903a480cf553ff9bf.svg";